/* ============================================
   SUHARA — Global JavaScript
   ============================================ */

window.Suhara = window.Suhara || {};

// Toast notification
Suhara.toast = function(msg) {
  var el = document.getElementById('suhara-toast');
  if (!el) return;
  el.querySelector('.suhara-toast__message').textContent = msg;
  el.classList.add('is-visible');
  clearTimeout(Suhara.__toastTimer);
  Suhara.__toastTimer = setTimeout(function() {
    el.classList.remove('is-visible');
  }, 3000);
};

// Cart Drawer open/close
Suhara.openCart = function() {
  var d = document.getElementById('cart-drawer');
  var b = document.getElementById('cart-backdrop');
  if (!d) return;
  d.classList.add('is-open');
  if (b) b.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  d.focus({ preventScroll: true });
};

Suhara.closeCart = function() {
  var d = document.getElementById('cart-drawer');
  var b = document.getElementById('cart-backdrop');
  if (d) d.classList.remove('is-open');
  if (b) b.classList.remove('is-open');
  document.body.style.overflow = '';
};

// Update cart counter badges
Suhara.updateCount = function(count) {
  var toggle = document.getElementById('cart-toggle');
  if (!toggle) return;
  var badge = document.getElementById('cart-count');
  if (count > 0) {
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'header__cart-count';
      badge.id = 'cart-count';
      toggle.appendChild(badge);
    }
    badge.textContent = count;
  } else if (badge) {
    badge.remove();
  }
  toggle.setAttribute('aria-label', 'Cart (' + count + ' items)');
};

// Refresh Cart Drawer HTML using Section Rendering API
Suhara.refreshCart = function(open) {
  var sectionId = 'suhara-cart-drawer';
  return fetch(window.location.pathname + '?sections=' + sectionId)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var html = data[sectionId];
      var wrap = document.getElementById('shopify-section-suhara-cart-drawer');
      if (html && wrap) {
        var wasOpen = open || (document.getElementById('cart-drawer') || {}).classList && document.getElementById('cart-drawer').classList.contains('is-open');
        var t = document.createElement('div');
        t.innerHTML = html;
        wrap.innerHTML = html;
        if (wasOpen) Suhara.openCart();
        if (Suhara.loadRecommendations) Suhara.loadRecommendations();
        if (Suhara.updateCartDeliveryDate) Suhara.updateCartDeliveryDate();
      }
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          Suhara.updateCount(cart.item_count);
          return cart;
        });
    });
};

// Update Cart line item quantity
Suhara.updateCart = function(line, quantity, btn) {
  if (btn) btn.disabled = true;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(err) { throw new Error(err.description || 'Could not update cart'); });
    return r.json();
  })
  .then(function() {
    if (quantity === 0) {
      Suhara.toast('Item removed from cart');
    }
    return Suhara.refreshCart(true);
  })
  .catch(function(err) {
    Suhara.toast(err.message || 'Could not update cart. Please try again.');
    if (btn) btn.disabled = false;
  });
};

// Apply Discount Coupon in Cart Drawer
Suhara.applyDiscount = function(btn) {
  var scope = btn && btn.closest && btn.closest('[data-coupon]');
  var input = scope ? scope.querySelector('input') : document.getElementById('coupon-input');
  var code = input && input.value.trim();
  if (!code) {
    Suhara.toast('Enter a discount code first');
    return;
  }
  if (btn) btn.disabled = true;
  fetch('/discount/' + encodeURIComponent(code))
    .then(function() {
      Suhara.toast(code.toUpperCase() + ' will be applied at checkout');
    })
    .catch(function() {
      Suhara.toast('Apply your code at checkout');
    })
    .then(function() {
      if (btn) btn.disabled = false;
    });
};

// legacy compatibility helper for addToCart
Suhara.addToCart = function(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(err) { throw new Error(err.description || 'Could not add to cart'); });
    return r.json();
  })
  .then(function() {
    return Suhara.refreshCart(true);
  })
  .catch(function(err) {
    Suhara.toast(err.message || 'Could not add to cart. Please try again.');
  });
};

// legacy compatibility helper for refreshCartCount
Suhara.refreshCartCount = function() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      Suhara.updateCount(cart.item_count);
    });
};

// Scroll reveal animation
(function() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(function(el) {
    observer.observe(el);
  });
})();

// Delegated event listeners for cart UI (survive drawer re-renders)
document.addEventListener('click', function(e) {
  if (e.target.closest('#cart-close') || e.target.closest('#cart-backdrop')) {
    Suhara.closeCart();
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    Suhara.closeCart();
  }
});

// Intercept add-to-cart forms for AJAX
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form.matches('form[action*="/cart/add"]')) return;
  e.preventDefault();
  
  var btn = form.querySelector('[type="submit"]');
  var original = btn ? btn.textContent : '';
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Adding…';
  }
  
  var formData = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: formData
  })
  .then(function(r) {
    if (!r.ok) {
      return r.json().then(function(err) {
        throw new Error(err.description || 'Could not add to cart');
      });
    }
    return r.json();
  })
  .then(function() {
    return Suhara.refreshCart(true);
  })
  .then(function() {
    if (btn) {
      btn.textContent = 'Added ✓';
      setTimeout(function() {
        btn.textContent = original;
        btn.disabled = false;
      }, 2000);
    }
  })
  .catch(function(err) {
    Suhara.toast(err.message || 'Could not add to cart');
    if (btn) {
      btn.textContent = original;
      btn.disabled = false;
    }
  });
});

// Auto-open Cart Drawer when standard theme components add items to cart
document.addEventListener('shopify:cart:lines-update', function(e) {
  if (e.detail && e.detail.action === 'add' && e.detail.promise) {
    e.detail.promise.then(function(result) {
      if (result && result.detail && !result.detail.didError) {
        Suhara.refreshCart(true);
      }
    }).catch(function(err) {
      console.error('[suhara-global] Failed to handle cart add event:', err);
    });
  }
});

// Dynamic Cart Drawer Recommendations
Suhara.loadRecommendations = function() {
  var recContainer = document.getElementById('cart-recommendations');
  if (!recContainer) return;
  var productId = recContainer.dataset.productId;
  var grid = document.getElementById('cart-rec-grid');
  if (!productId || !grid) return;

  fetch('/recommendations/products.json?product_id=' + productId + '&limit=3')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var products = data.products || [];
      if (products.length === 0) {
        recContainer.style.display = 'none';
        return;
      }
      grid.innerHTML = '';
      products.forEach(function(prod) {
        var card = document.createElement('div');
        card.className = 'cart-rec-card';
        
        var priceFormatted = 'Rs. ' + (prod.price / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 });
        var firstVariantId = prod.variants && prod.variants[0] ? prod.variants[0].id : '';
        
        var imgUrl = prod.featured_image || '';
        if (imgUrl.indexOf('?') === -1) imgUrl += '?';
        imgUrl += '&width=120';

        card.innerHTML = 
          '<img class="cart-rec-card__img" src="' + imgUrl + '" alt="' + prod.title + '">' +
          '<div class="cart-rec-card__info">' +
            '<a class="cart-rec-card__name" href="' + prod.url + '">' + prod.title + '</a>' +
            '<span class="cart-rec-card__price">' + priceFormatted + '</span>' +
          '</div>' +
          (firstVariantId ? '<button type="button" class="btn btn--secondary btn--sm cart-rec-card__btn" onclick="Suhara.addToCart(' + firstVariantId + ', 1)">+ Add</button>' : '');
        
        grid.appendChild(card);
      });
    })
    .catch(function() {
      recContainer.style.display = 'none';
    });
};

// Dynamic Cart Drawer Delivery Date
Suhara.updateCartDeliveryDate = function() {
  var el = document.getElementById('cart-delivery-est');
  if (!el) return;
  
  var today = new Date();
  var minDays = 3;
  var maxDays = 7;
  
  var minDate = new Date(today);
  minDate.setDate(today.getDate() + minDays);
  
  var maxDate = new Date(today);
  maxDate.setDate(today.getDate() + maxDays);
  
  var options = { weekday: 'short', month: 'short', day: 'numeric' };
  var minStr = minDate.toLocaleDateString('en-IN', options);
  var maxStr = maxDate.toLocaleDateString('en-IN', options);
  
  el.innerHTML = '🚚 Estimated delivery: <strong>' + minStr + ' – ' + maxStr + '</strong>';
};

// Initialize elements on DOM content loaded
(function() {
  // Run cart recommendations & delivery initializers
  if (Suhara.loadRecommendations) Suhara.loadRecommendations();
  if (Suhara.updateCartDeliveryDate) Suhara.updateCartDeliveryDate();

  // Dynamic Table of Contents for Policy Pages
  if (document.body.classList.contains('template-policy') || window.location.pathname.indexOf('/policies/') !== -1) {
    var policyContainer = document.querySelector('.shopify-policy__body') || document.querySelector('.policy__body') || document.querySelector('main');
    if (policyContainer) {
      var headings = policyContainer.querySelectorAll('h2, h3');
      if (headings.length > 2) {
        var toc = document.createElement('div');
        toc.className = 'policy-toc';
        var tocTitle = document.createElement('h4');
        tocTitle.textContent = 'Table of Contents';
        toc.appendChild(tocTitle);
        var list = document.createElement('ul');
        headings.forEach(function(h, idx) {
          var id = h.id || 'policy-sec-' + idx;
          h.id = id;
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + id;
          a.textContent = h.textContent;
          a.className = 'policy-toc-link policy-toc-link--' + h.tagName.toLowerCase();
          li.appendChild(a);
          list.appendChild(li);
        });
        toc.appendChild(list);
        policyContainer.insertBefore(toc, policyContainer.firstChild);
      }
    }
  }
})();
